// API imperativa globale per dialoghi/notifiche in stile app. Usabile OVUNQUE
// (componenti, hook, util, config). Backed da AppDialogHost; fallback al nativo se assente.
export type ToastKind = 'success' | 'error' | 'info' | 'warning';
export type AlertOpts = { title?: string; confirmText?: string; variant?: 'danger' | 'warning' | 'info' };
export type ConfirmOpts = AlertOpts & { cancelText?: string };

export interface DialogHost {
  alert: (message: string, opts?: AlertOpts) => Promise<void>;
  confirm: (message: string, opts?: ConfirmOpts) => Promise<boolean>;
  toast: (kind: ToastKind, message: string, title?: string) => void;
}

let host: DialogHost | null = null;
export function _registerDialogHost(h: DialogHost | null) { host = h; }

export function appAlert(message: string, opts?: AlertOpts): Promise<void> {
  if (host) return host.alert(message, opts);
  window.alert(message); return Promise.resolve();
}
export function appConfirm(message: string, opts?: ConfirmOpts): Promise<boolean> {
  if (host) return host.confirm(message, opts);
  return Promise.resolve(window.confirm(message));
}
export const appToast = {
  success: (m: string, t?: string) => host ? host.toast('success', m, t) : window.alert(m),
  error:   (m: string, t?: string) => host ? host.toast('error', m, t)   : window.alert(m),
  info:    (m: string, t?: string) => host ? host.toast('info', m, t)    : window.alert(m),
  warning: (m: string, t?: string) => host ? host.toast('warning', m, t) : window.alert(m),
};
